import {Field, FieldArray, reduxForm} from 'redux-form'
import {OverlayTrigger, Popover} from 'react-bootstrap'
import LabelSection from 'components/sections/LabelSection'
import SettingField from 'components/Fields/ReduxForm/SettingField'

import styles from './TransferForm.css'
import ConfirmSubmitModal from './ConfirmSubmitModal'

import {
  NAMESPACE_ITEMS,
  NAMESPACE_INGREDIENTS
} from 'actions/inventory/constants'

const lessThanEqualInStock = (index) =>
  (value, previousValue, allValues) => {
    if (value) {
      if (parseFloat(value) < parseFloat(allValues.transfers[index].inStock)) {
        return value
      } else {
        return allValues.transfers[index].inStock < 0 ? 0 : allValues.transfers[index].inStock
      }
    } else {
      return value
    }
  }

const validate = (values, props) => {
  const {transfers} = values
  const errors = {}
  const transferErrors = []

  if (transfers) {
    transfers.forEach((trf, index) => {
      const transferError = {}
      if (!trf.quantity && '' + trf.quantity !== '0') {
        transferError.quantity = 'Please enter a valid value'
        transferErrors[index] = transferError
      } else if (props.searchForm.namespace === NAMESPACE_INGREDIENTS && parseFloat(trf.quantity) < 0.01) {
        transferError.quantity = 'Quantity must greater than or equal 0.01'
        transferErrors[index] = transferError
      }
    })
  }
  if (transferErrors.length) {
    errors.transfers = transferErrors
  }
  return errors
}

const popoverFocus = ({content}) => (
  <Popover id='transfer'>
    {content}
  </Popover>
)

const renderTransfer = (member, index, fields) => {
  const transferObject = fields.get(index)
  return (<div className='col-sm-12 mk-grouped-input'>
    <div className='form-group col-sm-4'>
      {!transferObject.isItem &&
        <OverlayTrigger placement='top' overlay={popoverFocus({content: transferObject.itemVariantName})}>
          <Field
            component='input'
            name={`${member}.itemVariantName`}
            className={`form-control ${styles['item-variant-name']}`}
            disabled
          />
        </OverlayTrigger>}
      {transferObject.isItem &&
        <OverlayTrigger placement='top' overlay={popoverFocus({content: transferObject.itemName})}>
          <Field
            component='input'
            name={`${member}.itemName`}
            className={`form-control ${styles['item-name']}`}
            disabled
          />
        </OverlayTrigger>}
    </div>
    <div className='form-group col-sm-4'>
      <Field
        component='input'
        name={`${member}.inStock`}
        className={`form-control ${styles['in-stock']}`}
        disabled
        />
    </div>
    <div className='form-group col-sm-4'>
      <Field
        component={SettingField}
        name={`${member}.quantity`}
        className='form-control'
        normalize={lessThanEqualInStock(index)}
        inputClassName={transferObject.isItem ? `${styles['last-input']}` : ''}
        feedbackClassName={transferObject.isItem ? `${styles['feedback']}` : ''}
        positiveNumberOnly
        maxFractionDigits={0}
        />
      {transferObject.isItem && <span onClick={() => { fields.remove(index) }} className={styles['btn-delete-wrapper']}>
        <i className='fa fa-times-circle' />
      </span>}
    </div>
  </div>)
}

const renderTransferArray = ({fields, meta}) => {
  let lastItemId = 0
  const doms = []
  let inputdoms = []

  fields.forEach((...props) => {
    const [member, index] = props
    const field = fields.get(index)
    const shouldRenderHeader = lastItemId === 0 || (field.itemId !== lastItemId)
    const shouldRenderItemNameRow = (!field.isItem)
    lastItemId = field.itemId

    if (shouldRenderHeader) {
      if (inputdoms.length) {
        doms.push(<div className='row mb-20px'><div className='col-sm-12'>{inputdoms}</div></div>)
        inputdoms = []
      }
      doms.push(<div className='col-sm-12 mt-10px mb-10px'>
        <div className='col-sm-4 text-center'>
          {!field.isItem && 'VARIANT'}
          {field.isItem && 'ITEM'}
        </div>
        <div className='col-sm-4 text-center'>
          IN STOCK
        </div>
        <div className='col-sm-4 text-center'>
          QUANTITY
        </div>
      </div>)
    }

    if (shouldRenderHeader && shouldRenderItemNameRow) {
      inputdoms.push(<div className='col-sm-12 mk-grouped-input'>
        <div className='form-group col-sm-12' style={{paddingRight: 1}}>
          <Field
            component='input'
            name={`${member}.itemName`}
            className={`form-control ${styles['item-name-header']}`}
            disabled
          />
          <span onClick={() => {
            // use counter because when remove index, fields immediately shifts up
            let i = 0
            fields.getAll().forEach((tmp, idx) => {
              if (tmp.itemId === field.itemId) {
                fields.remove(idx - i)
                i++
              }
            })
          }} className={styles['btn-delete-wrapper']}>
            <i className='fa fa-times-circle' />
          </span>
        </div>
      </div>)
    }
    inputdoms.push(renderTransfer(...props))
  })
  if (inputdoms.length) {
    doms.push(<div className='row mb-20px'><div className='col-sm-12'>{inputdoms}</div></div>)
  }
  return (
    <div className={`row mk-grouped-list-input ${styles['transfer-item-wrapper']}`}>
      {doms}
    </div>)
}

const renderIngredientTransfer = (member, index, fields) => {
  const transferObject = fields.get(index)
  return (<div className='col-sm-12 mk-grouped-input'>
    <div className='form-group col-sm-4'>
      <OverlayTrigger placement='top' overlay={popoverFocus({content: transferObject.unitName})}>
        <Field
          component='input'
          name={`${member}.unitName`}
          className={`form-control ${styles['ingredient-unit-name']}`}
          disabled
          />
      </OverlayTrigger>
    </div>
    <div className='form-group col-sm-4'>
      <Field
        component='input'
        name={`${member}.inStock`}
        className={`form-control ${styles['in-stock']}`}
        disabled
        />
    </div>
    <div className='form-group col-sm-4'>
      <Field
        component={SettingField}
        name={`${member}.quantity`}
        className='form-control'
        positiveNumberOnly
        normalize={lessThanEqualInStock(index)}
        inputClassName={`${styles['last-input']}`}
        feedbackClassName={`${styles['feedback']}`}
        maxFractionDigits={2}
        />
      <span onClick={() => { fields.remove(index) }} className={styles['btn-delete-wrapper']}>
        <i className='fa fa-times-circle' />
      </span>
    </div>
  </div>)
}

const renderIngredientTransferArray = ({fields, meta}) => {
  const doms = []

  fields.forEach((...props) => {
    const [member] = props

    doms.push(<div className='col-sm-12 mt-10px mb-10px'>
      <div className='col-sm-4 text-center'>
          UNIT
        </div>
      <div className='col-sm-4 text-center'>
          IN STOCK
        </div>
      <div className='col-sm-4 text-center'>
          QUANTITY
        </div>
    </div>)
    doms.push(<div className='col-sm-12 mk-grouped-input' style={{paddingRight: 16}}>
      <div className='form-group col-sm-12'>
        <Field
          component='input'
          name={`${member}.ingredientName`}
          className={`form-control ${styles['ingredient-name-header']}`}
          disabled
        />
      </div>
    </div>)

    doms.push(<div className='row mb-20px'>
      <div className='col-sm-12'>
        {renderIngredientTransfer(...props)}
      </div>
    </div>)
  })

  return (<div className={`row mk-grouped-list-input ${styles['transfer-item-wrapper']}`}>
    {doms}
  </div>)
}

class TransferForm extends React.Component {
  _renderSelectOutlet = (field) => {
    const {label, outlets, selectedOutlets} = field

    if (outlets.length === 0 || selectedOutlets.length === 0) {
      return (<div className='form-group'>
        <label>{label}</label>
        <select
          {...field.input}
          className='form-control'
          disabled >
          <option value='' disabled selected>Loading...</option>
        </select>
      </div>)
    }

    return (<div className='form-group'>
      <label>{label}</label>
      <select
        {...field.input}
        className='form-control'
        disabled={selectedOutlets.length === 1 && label === 'FROM'} >
        {label === 'FROM' && selectedOutlets.length === 1 && <option value={selectedOutlets[0].id}>{selectedOutlets[0].name}</option>}
        {label === 'FROM' && selectedOutlets.length > 1 && outlets.map(outlet => {
          return (
            <option
              value={outlet.id}>
              {outlet.name}
            </option>
          )
        })}
        {label === 'TO' && outlets.map(outlet => {
          return (
            <option
              selected={selectedOutlets[0].id === outlet.id}
              value={outlet.id}>
              {outlet.name}
            </option>
          )
        })}
      </select>
    </div>)
  }

  render () {
    let {
      outlets,
      selectedOutlets,
      onFromOutletChange,
      showConfirmSubmitModal,
      setShowConfirmSubmitModal,
      onConfirmCreateTransfer,
      searchForm,
      confirmCreateButtonStatus,
      handleSubmit
    } = this.props

    return (<form onSubmit={handleSubmit(this._onSubmit)} className={styles.wrapper}>
      <div className={`${styles['form-content']} transfer-form-content`}>
        <LabelSection title='choose outlet' />
        <div className='form-group'>
          <Field
            label='FROM'
            name='fromOutlet'
            outlets={outlets}
            selectedOutlets={selectedOutlets}
            onChange={onFromOutletChange}
            component={this._renderSelectOutlet} />
          <Field
            label='TO'
            name='toOutlet'
            outlets={outlets}
            selectedOutlets={selectedOutlets}
            component={this._renderSelectOutlet} />
        </div>
        <LabelSection title='note' />
        <div className='form-group mb-20px'>
          <Field
            component='textarea'
            placeholder='Notes'
            name='notes'
            className='form-control'
            rows={5}
            />
        </div>
        <LabelSection title='transfer stock table' />
        <div className='mb-20px'>
          <FieldArray name='transfers' component={searchForm && searchForm.namespace === NAMESPACE_ITEMS ? renderTransferArray : renderIngredientTransferArray} />
        </div>
        <div className='form-group'>
          <button className={'btn btn-primary ' + styles['btn-addItems']}
            onClick={this._onClickAddItems}>
            {searchForm && searchForm.namespace === NAMESPACE_ITEMS ? 'Add Items' : 'Add Ingredients'}
          </button>
        </div>
      </div>
      <div className={styles['form-footer']}>
        <span className='pull-right'>
          <button
            className={`btn btn-default ${styles['btn-done']} mr-10px`}
            onClick={this._onClickCancel}
            type='button'>
                Cancel
              </button>
          <button
            className={`btn btn-primary ${styles['btn-done']}`}
            type='submit'>
                Create
              </button>
        </span>
      </div>
      <ConfirmSubmitModal
        showConfirmSubmitModal={showConfirmSubmitModal}
        setShowConfirmSubmitModal={setShowConfirmSubmitModal}
        onConfirmCreateTransfer={onConfirmCreateTransfer}
        confirmCreateButtonStatus={confirmCreateButtonStatus} />
    </form>)
  }

  // when clicked add items in create transfer form
  _onClickAddItems = (event) => {
    const {onClickAddItem} = this.props
    event.preventDefault()
    event.stopPropagation()
    onClickAddItem()
  }

  _onSubmit = (values) => {
    const {onSubmitCreateTransferForm} = this.props
    onSubmitCreateTransferForm(values)
  }

  // when clicked cancel in create transfer form
  _onClickCancel = () => {
    const {reset, onClickDone} = this.props
    reset()
    onClickDone()
  }
}

const mapForm = {
  form: 'transferItem',
  validate,
  touchOnBlur: true,
  touchOnChange: true
}

export default reduxForm(mapForm)(TransferForm)



// WEBPACK FOOTER //
// ./app/pages/Inventory/Transfer/TransferDetail/TransferForm/TransferForm.js